export default __webpack_public_path__ + "static/media/map_view_no_results.ab8871b6.svg";